<template>
  <div class="zrsdq_tx">
    <div>
      <!-- <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            style="display: flex"
            :model="searchForm"
            label-position="center"
            label-width="90px"
          >
            <el-form-item label="责任书名称:">
              <el-input
                v-model="searchForm.xkzbh"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="下拉类型">
              <el-select v-model="searchForm.hxp" placeholder="">
                <el-option label="item.label" value="item.value"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="剩余有效期:" style="">
              <el-col :span="10">
                <el-date-picker
                  type="date"
                  style="width: 100%"
                  placeholder="开始时间"
                  v-model="searchForm.kssj"
                ></el-date-picker>
              </el-col>
              <el-col style="text-align: center" class="line" :span="3"
                >-</el-col
              >
              <el-col :span="10">
                <el-date-picker
                  type="date"
                  style="width: 100%"
                  placeholder="结束时间"
                  v-model="searchForm.jssj"
                ></el-date-picker>
              </el-col>
            </el-form-item>

            <el-button
              class="sousuoButton"
              icon="el-icon-search"
              size="small"
              type="primary"
              >搜索</el-button
            >
          </el-form>
        </div>
      </div> -->
      <div
        style="
          margin: auto;
          width: 95%;
          max-width: 1518px;
          background-color: white;
          padding-top: 25px;
          padding-bottom: 51px;
          margin-top: 20px;
        "
      >
        <div class="tablemes">
          <el-button
            v-preventReClick
            type="primary"
            style="margin-bottom: 25px"
            @click="getlist()"
          >刷新</el-button>
          <el-table
            ref="cktable"
            :data="tableData"
            border
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
          >
            <el-table-column
              v-for="(item, i) in table"
              :key="i"
              :show-overflow-tooltip="true"
              align="center"
              :label="item.label"
            >
              <template slot-scope="scope">
                <span>
                  {{ scope.row[item.key] }}
                </span>
              </template>
            </el-table-column>
            <el-table-column header-align="center" align="center" label="操作">
              <template slot-scope="scope">
                <span>
                  <el-button
                    v-preventReClick
                    type="primary"
                    size="mini"
                    @click="operation(scope.row.xkzbh)"
                  >操作</el-button>
                </span>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :page-sizes="[10, 20, 30, 40]"
            :total="total"
            :page-size="pagesize"
            class="el-page"
            @current-change="currentpage"
            @size-change="sizechange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 获取接口地址
import { zrsdqtxList } from '@/assets/js/notification'

export default {
  components: {},
  props: {},
  data() {
    return {
      pupopShow: false,
      // searchForm: {
      //   xkzbh: "",
      //   hxp: "",
      //   kssj: "",
      //   jssj: "",
      // },
      table: [
        {
          key: 'qdrq',
          label: '签订日期'
        },
        {
          key: 'syyxts',
          label: '剩余有效天数'
        },
        {
          key: 'tsxx',
          label: '提示消息'
        }
      ],
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10 // 每页的数据条数
    }
  },
  mounted() {
    // 获取列表
    this.getlist()
  },
  methods: {
    // 获取列表
    getlist() {
      zrsdqtxList({
        page: this.currentPage,
        size: this.pagesize,
        param: {}
      }).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 翻页
    currentpage(e) {
      this.currentPage = e
      // 获取列表
      this.getlist()
    },
    // 修改每页条数
    sizechange(e) {
      this.pagesize = e
      // 获取列表
      this.getlist()
    },
    operation(id) {
      this.$router.push({ name: `Zrsqd`, params: { id: id }})
    }
  }
}
</script>
<style scoped lang='less'>
.el-table--border {
  z-index: 0;
}
.resetbutton {
  width: 90px;
  height: 39px;
  border-radius: 20px;
}
.zrsdq_tx {
  // height: 100%;
  // width: 90%;
  // background-color: white;
  // margin: auto;
  .headerSearch {
    max-width: 1518px;
    width: 95%;
    margin: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-color: #4170ff;
    }
    .chongzhiButton {
      width: 90px;
      height: 39px;
    }
  }
  .tablemes {
    margin: auto;
    width: 90%;
    max-width: 1375px;
    margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .el-button--warning {
      color: #fff;
      background: #feb800;
      border-radius: 3px;
      border-color: #feb800;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
</style>
